import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerProducer } from "../services/dbMariaAuth";

const ProducerRegister: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [brand, setBrand] = useState("");
  const [producerId, setProducerId] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
     if (!brand.trim()) throw new Error("Brand is required.");
     if (!producerId.trim()) throw new Error("ProducerId is required.");

     const user = await registerProducer({ email, password, brand, producerId });
     if (!user || user.role !== "producer") {
       throw new Error("Registration succeeded, but the server did not return a producer role.");
     }

     setSuccess("Producer account created. Redirecting...");
     setEmail("");
     setPassword("");
     setBrand("");
     setProducerId("");
     setTimeout(() => navigate("/my-bikes", { replace: true }), 1200);
    } catch (err: any) {
     let errorMessage = "Registration error. Please try again.";
     if (err?.message) {
       errorMessage = err.message;
     }
     setError(errorMessage);
    } finally {
     setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", backgroundColor: "#0a192f", color: "#e6f1ff" }}>
      <div style={{ width: "370px", padding: "30px", boxShadow: "0 10px 20px rgba(0,0,0,0.3)", borderRadius: "8px", backgroundColor: "#112240" }}>
          <h1 style={{ textAlign: "center", color: "#64ffda" }}>Producer Registration</h1>
          <h3 style={{ textAlign: "center", marginBottom: "30px", color: "#ccd6f6" }}>Create a producer account</h3>
        {error && <div style={{ color: "#ff6b6b", marginBottom: "15px", textAlign: "center" }}>{error}</div>}
        {success && <div style={{ color: "#64ffda", marginBottom: "15px", textAlign: "center" }}>{success}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "18px" }}>
                  <label style={{ display: "block", marginBottom: "8px", color: "#8892b0" }}>Email:</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={{ width: "100%", padding: "12px", backgroundColor: "#1e2d45", color: "#e6f1ff", border: "1px solid #3a506b", borderRadius: "4px" }} />
          </div>
          <div style={{ marginBottom: "18px" }}>
                  <label style={{ display: "block", marginBottom: "8px", color: "#8892b0" }}>Password:</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ width: "100%", padding: "12px", backgroundColor: "#1e2d45", color: "#e6f1ff", border: "1px solid #3a506b", borderRadius: "4px" }} />
          </div>
          <div style={{ marginBottom: "18px" }}>
                  <label style={{ display: "block", marginBottom: "8px", color: "#8892b0" }}>Brand:</label>
            <input type="text" value={brand} onChange={e => setBrand(e.target.value)} required style={{ width: "100%", padding: "12px", backgroundColor: "#1e2d45", color: "#e6f1ff", border: "1px solid #3a506b", borderRadius: "4px" }} />
          </div>
          <div style={{ marginBottom: "25px" }}>
                  <label style={{ display: "block", marginBottom: "8px", color: "#8892b0" }}>Producer ID:</label>
            <input type="text" value={producerId} onChange={e => setProducerId(e.target.value)} required style={{ width: "100%", padding: "12px", backgroundColor: "#1e2d45", color: "#e6f1ff", border: "1px solid #3a506b", borderRadius: "4px" }} />
          </div>
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "14px", backgroundColor: "#64ffda", color: "#0a192f", border: "none", borderRadius: "4px", cursor: loading ? "not-allowed" : "pointer", fontWeight: "bold", fontSize: "16px", transition: "background-color 0.3s" }}>
                  {loading ? "Registering..." : "Register producer"}
          </button>
        </form>
        <div style={{ marginTop: "18px", textAlign: "center" }}>
              <a href="/login" style={{ color: "#64ffda", textDecoration: "underline" }}>Already have an account? Log in</a>
        </div>
      </div>
    </div>
  );
};

export default ProducerRegister;
